__turbopack_context__.v({
  "filterMenuContainer": "styles-module-scss-module__oPZgbG__filterMenuContainer",
  "imageSearchBanner": "styles-module-scss-module__oPZgbG__imageSearchBanner",
  "imageSearchContent": "styles-module-scss-module__oPZgbG__imageSearchContent",
  "loadingContent": "styles-module-scss-module__oPZgbG__loadingContent",
  "loadingFilterMenu": "styles-module-scss-module__oPZgbG__loadingFilterMenu",
  "loadingGrid": "styles-module-scss-module__oPZgbG__loadingGrid",
  "loadingSearchBar": "styles-module-scss-module__oPZgbG__loadingSearchBar",
  "resultsContainer": "styles-module-scss-module__oPZgbG__resultsContainer",
  "searchPage": "styles-module-scss-module__oPZgbG__searchPage",
  "srOnly": "styles-module-scss-module__oPZgbG__srOnly",
  "teaserGrid": "styles-module-scss-module__oPZgbG__teaserGrid",
});
